<template>
  <v-container
    class="d-flex align-center justify-center fill-height"
    v-if="isSettingLoaded">
    <v-row>
      <v-col sm="8" md="6" lg="4" class="offset-md-3 offset-sm-2 offset-lg-4">
        <v-btn
          block
          class="refresh"
          @click="syncAventri()"
          :disabled="isAventriSyncing || isLoading">
          <template v-if="!isAventriSyncing">{{
            $t("refreshPage.refreshButton")
          }}</template>
          <template v-if="isAventriSyncing">
            <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
          </template>
        </v-btn>
        <div v-if="isAventriSyncing" class="d-flex justify-center pt-3">
          {{ $t("refreshPage.syncInProgressLine1") }}
        </div>
        <div v-if="isAventriSyncing" class="d-flex justify-center">
          {{ $t("refreshPage.syncInProgressLine2") }}
        </div>
        <div v-if="isAventriSyncSuccessful" class="d-flex justify-center pt-3">
          <span class="green--text">{{
            $t("refreshPage.syncSuccessful")
          }}</span>
        </div>
        <div v-if="isAventriSyncInError" class="d-flex justify-center pt-3">
          <span class="red--text"
            >{{ $t("refreshPage.syncInErrorLine1") }}<br /><br />{{
              $t("refreshPage.syncInErrorLine2")
            }}
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "../plugins/axios";

export default {
  name: "Refresh",
  data: () => ({
    isLoading: true,
    isAventriSyncing: false,
    isAventriSyncSuccessful: false,
    isAventriSyncInError: false,
    syncId: null,
    intervalId: null,
  }),
  methods: {
    setSyncStatus(syncResult) {
      let syncStatus = syncResult.status;
      if (syncStatus == 0) {
        this.isAventriSyncing = false;
        this.isAventriSyncSuccessful = false;
        this.isAventriSyncInError = false;
        clearInterval(this.intervalId);
        this.intervalId = null;
      } else if (syncStatus == 1) {
        this.syncId = syncResult.id;
        this.isAventriSyncing = true;
        this.isAventriSyncSuccessful = false;
        this.isAventriSyncInError = false;
        this.isSyncing();
      } else if (syncStatus == 2) {
        this.isAventriSyncing = false;
        this.isAventriSyncSuccessful = true;
        this.isAventriSyncInError = false;
        clearInterval(this.intervalId);
        this.intervalId = null;
      } else if (syncStatus == 3) {
        this.isAventriSyncing = false;
        this.isAventriSyncSuccessful = false;
        this.isAventriSyncInError = true;
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    callIsSyncing() {
      const queryParams = {
        syncId: this.syncId,
      };

      axios
        .get(`/Aventry/refresh/${this.getEventId}/isSyncRunning`, {
          params: queryParams,
        })
        .then((response) => {
          this.setSyncStatus(response.data);
        })
        .catch(() => {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.isAventriSyncInError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    isSyncing() {
      if (this.intervalId == null)
        this.intervalId = setInterval(() => this.callIsSyncing(), 30000);
    },
    syncAventri() {
      this.isAventriSyncing = true;
      this.isAventriSyncSuccessful = false;
      this.isAventriSyncInError = false;
      axios
        .get(`/Aventry/refresh/${this.getEventId}`, {})
        .then((response) => {
          this.setSyncStatus(response.data);
          this.isSyncing();
        })
        .catch(() => {
          this.isAventriSyncInError = true;
        })
        .finally(() => {});
    },
  },
  computed: {
    getEventId: {
      get() {
        return this.$store.getters["getEventId"];
      },
    },

    isSettingLoaded() {
      return this.$store.getters["getIsSettingLoaded"];
    },
  },
  created() {
    this.callIsSyncing();
  },
};
</script>
